// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"450":"eacaff21","865":"16afb27e"}[chunkId] + ".css";
};